module.exports = __webpack_public_path__ + "img/256x256_hexagon.8e841c0e.svg";